import styled from 'styled-components';

export const InfoBarListContainer = styled.ul`
  list-style: none;
  display: flex;
  align-items: center;
  padding: 0.5rem 0;
  margin: 0;
`;
